var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_vm._t("default"),(_vm.showHeader)?_c('div',{staticClass:"main_header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"main_center"},[_vm._t("center")],2),(_vm.showFooter)?_c('div',{staticClass:"main_footer"},[_vm._t("footer")],2):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03bb9edc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/container/main/index.vue
// module id = null
// module chunks = 